<div class="card">
    <div class="card-header">
        Reporting to Employee
    </div>
    <div class="card-body">
        <div class="row m-1">
            <div class="col-md-3 px-1">
                <label class="Label">Employee Type:</label>
            </div>
            <div class="col px-1">
                <label class="form-check-label link-dark px-1 text-label-light">
                    <input class="form-check-input" type="radio" name="Employee" value="User"
                        [(ngModel)]="SelectApprovalType" (click)="onSelectionChange('Employee',$event)"> User
                </label>
                &nbsp;&nbsp;&nbsp; &nbsp;&nbsp; <label class="form-check-label link-dark px-1 text-label-light">
                    <input class="form-check-input" type="radio" name="Employee" value="Shift"
                        [(ngModel)]="SelectApprovalType" (click)="onSelectionChange('Employee',$event)"> Shift
                </label>
                &nbsp;&nbsp;&nbsp; &nbsp;&nbsp; <label class="form-check-label link-dark px-1 text-label-light">
                    <input class="form-check-input" type="radio" name="Employee" value="Department"
                        [(ngModel)]="SelectApprovalType" (click)="onSelectionChange('Employee',$event)"> Department
                </label>
            </div>
        </div>
        <div class="row m-1" *ngIf="this.SelectApprovalType == 'User'">
            <div class="col-md-2 px-1">
                <label class="Label">User :</label>
            </div>
            <div class="col-md-4 px-1">
                <ng-select name="user" [items]="UserLoad" bindLabel="UserName" bindValue="UserMasterId"
                    [(ngModel)]="UserID" placeholder="Select User">
                    <ng-option *ngFor="let segment of UserLoad" [value]="segment.UserMasterId">
                        {{ segment.UserName }}
                    </ng-option>
                </ng-select>
            </div>
            <div class="col px-1">
                <label class="form-check-label link-dark px-1 text-label-light">
                    <input class="form-check-input" type="radio" name="Reporting" value="rp1"
                        [(ngModel)]="Report" (click)="onSelectionChange('Reporting',$event)"> ReportingApproval1
                </label>
                &nbsp;&nbsp;&nbsp; &nbsp;&nbsp; <label class="form-check-label link-dark px-1 text-label-light">
                    <input class="form-check-input" type="radio" name="Reporting" value="rp2"
                        [(ngModel)]="Report" (click)="onSelectionChange('Reporting',$event)"> ReportingApproval2
                </label>
            </div>
        </div>
        <div class="row m-1" *ngIf="this.SelectApprovalType == 'Shift'">
            <div class="col-md-2 px-1">
                <label class="Label">Shift</label>
            </div>
            <div class="col-md-4 px-1">
                <ng-select name="Shift" [items]="Shift" bindLabel="ShiftTitle" bindValue="ShiftMasterID"
                    [(ngModel)]="ShiftID"  placeholder="Select Shift">
                    <ng-option *ngFor="let segment of Shift" [value]="segment.ShiftMasterID">
                        {{ segment.ShiftTitle }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row m-1" *ngIf="this.SelectApprovalType == 'Department'">
            <div class="col-md-2 px-1">
                <label class="Label">Department :</label>
            </div>
            <div class="col-md-4 px-1">
                <ng-select name="Department" [items]="DepartmentLoad" bindLabel="DepartmentName"
                    bindValue="DepartmentMasterID" [(ngModel)]="DepartmentId"  placeholder="Select Department">
                    <ng-option *ngFor="let segment of DepartmentLoad" [value]="segment.DepartmentMasterID">
                        {{ segment.DepartmentName }}
                    </ng-option>
                </ng-select>
            </div>
        </div>  
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button class="btn btn-sm btn-primary" name="cancel" (click)="cancel()">
                    <i class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}
                </button>
                &nbsp; <button class="btn btn-sm btn-primary" name="save" (click)="applyToSelected()" [disabled]="!isButtonEnabled()">
                    <i class="bi bi-save" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Apply to Selected':'Loading...'}}
                </button>
               &nbsp; <button class="btn btn-sm btn-primary" name="save" (click)="apply()" [disabled]="!isButtonEnabled()">
                    <i class="bi bi-save" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Apply all':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>